export const formikMultiValueFieldMessages = {
  en: {
    noneSelected: 'None',
    oneSelected: '1 selected',
    manySelected: '{count} selected',
  },
};
